import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminWrapperComponent } from './admin-wrapper/admin-wrapper.component';
import { UserListWrapperComponent } from './user-list-wrapper/user-list-wrapper.component';
import { PageTitleResolver } from '../services/page-title.resolver';
import { OrganisationListWrapperComponent } from './organisation-list-wrapper/organisation-list-wrapper.component';
import { UserOrgsSlideoutWrapperComponent } from './user-slideout/user-orgs-slideout-wrapper/user-orgs-slideout-wrapper.component';
import {
  UserRolesSlideoutWrapperComponent
} from './user-slideout/user-roles-slideout-wrapper/user-roles-slideout-wrapper.component';

const routes: Routes = [
  { path: '', redirectTo: 'users', pathMatch: 'full', title: PageTitleResolver },
  { path: '',
    component: AdminWrapperComponent,
    children: [
      { path: 'users',
        component: UserListWrapperComponent,
        title: PageTitleResolver,
        children: [
          { path: ':userId',
            children: [
              { path: '',
                redirectTo: 'organisations',
                pathMatch: 'full',
              },
              { path: 'organisations',
                component: UserOrgsSlideoutWrapperComponent,
                title: 'appName'
              },
              { path: 'roles',
                component: UserRolesSlideoutWrapperComponent,
                title: 'appName'
              }
            ]
          }
        ]
      },
      { path: 'organisations',
        component: OrganisationListWrapperComponent,
        title: 'appName',
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
